import type { Route } from '@angular/router';

export const reservationRoutes: Route[] = [
  {
    path: '',
    loadComponent: () =>
      import('./list/resource-reservation-list.component').then(
        ({ ResourceReservationListComponent }) => ResourceReservationListComponent,
      ),
    pathMatch: 'full',
  },
];
